import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Home from './routes/Home';
import Members from './routes/Members';
import Music from './routes/Music';
import TourDates from './routes/TourDates';

import { HashRouter, Route, Routes} from 'react-router-dom';

ReactDOM.render(
  <HashRouter basename="/">
    <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/members' element={<Members />} />
        <Route path='/music' element={<Music />} />
        <Route path='/tourdates' element={<TourDates />} />
      </Routes>

     
  </HashRouter>,
  document.getElementById('root')
);